import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
export const TextWrapper = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${COLORS.textGrey};
  padding: 16px 0;
  .top-header {
    font-size: 16px;
    padding-top: 16px;
  }

  .header {
    font-weight: bold;
    font-size: 24px;
    color: ${COLORS.materialUiTextFieldColor};
    border-bottom: 1px solid ${COLORS.grey200};
    padding: 20px 0px;
  }

  .sub-header {
    padding-bottom: 100px;
  }

  .footer {
    padding-top: 30px;
  }

  .item {
    font-size: 16px;
    border-bottom: 1px solid ${COLORS.grey200};
    padding: 20px 0px;
    align-items: center;
    cursor: pointer;
    img {
      float: right;
    }
  }
  span {
    font-weight: bold;
    color: ${COLORS.brandPrimary};
    cursor: pointer;
  }
`;
export const TicketSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 30px;
  padding: 0px 20px;
  text-align: center;
  padding-top: 25px;
  font-size: 16px;
  .header {
    font-weight: bold;
    font-size: 24px;
    color: ${COLORS.materialUiTextFieldColor};
  }
  .sub-header {
    font-weight: bold;
    color: ${COLORS.materialUiTextFieldColor};
  }
`;

export const InputBox = styled.div`
  padding: 16px 0px;
  .input-header {
    font-size: 14px;
    font-family: ${FONT_FAMILY.hellix.bold}!important;
    color: ${COLORS.materialUiTextFieldColor};
  }
  #error-msg {
    font-size: 11px;
    line-height: 16px;
    font-family: ${FONT_FAMILY.hellix.regular};
  }
`;

export const TextAreaField = styled.div`
  padding: 5px 0px;

  .input-header {
    font-size: 14px;
    font-family: ${FONT_FAMILY.hellix.bold} !important;
    color: ${COLORS.materialUiTextFieldColor};
    padding-top: 8px;
  }

  .text-area {
    margin-top: 4px;

    textarea {
      ::-webkit-input-placeholder {
        color: ${COLORS.textDarkGray} !important;
      }
    }
  }
`;
export const CountryDropdown = styled.div`
  margin-top: 16px;
  &:has(#error-msg:not(:empty)) {
    margin-bottom: 12px;
  }
  #error-msg {
    font-size: 11px;
    line-height: 16px;
    font-family: ${FONT_FAMILY.hellix.regular};
  }
`;
